<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "police-history",
  data() {
    return {
      loading: true,
      empty: false,
      index: 0,
      groupsCount: 0,
      policeTimer: null
    };
  },
  async mounted() {
    await this.deviceClass();
    this.policeMessage()
      .then(data => {
        let alarmList = [];
        let show_id = 1;
        data.forEach(item => {
          item.show_id = show_id;
          show_id++;
          this.$store.state.deviceClass.forEach(device => {
            if (device.device_data_id === item.device_data_id) {
              item.name = device.cn_data_name;
            }
          });
          if (item.trigger_conditions === 1) {
            item.str = `设备大于${item.max_value}报警`;
          } else if (item.trigger_conditions === 2) {
            item.str = `设备小于${item.min_value}报警`;
          } else if (item.trigger_conditions === 0) {
            item.str = "设备报警解除";
          } else {
            item.str = "状态未知";
          }
          alarmList.push(item);
        });
        show_id = null;
        // 是否添加定时滚动
        if (alarmList.length === 0) {
          // 关闭加载动画
          this.loading = false;
          this.empty = true;
        }
        if (alarmList.length <= 6) {
          this.$store.commit("dataPolice/setShowData", {
            showData: alarmList
          });
        } else {
          let policeMessage = this.createDataGroup(alarmList);
          this.$store.commit("dataPolice/setPoliceMessage", {
            policeMessage: policeMessage
          });
          this.groupsCount = policeMessage.length - 1;
          // 设置初始显示组
          this.$store.commit("dataPolice/setShowData", {
            showData: this.$store.state.dataPolice.policeMessage[0]
          });
          this.index++;
          // 每3秒更换显示组的数据
          this.policeTimer = setInterval(() => {
            if (this.index > this.groupsCount) {
              this.index = 0;
            }
            this.$store.commit("dataPolice/setShowData", {
              showData: this.$store.state.dataPolice.policeMessage[this.index]
            });
            this.index++;
          }, 3000);
        }
        // 关闭加载动画
        this.loading = false;
      })
      .catch(error => {
        console.error(error);
        this.loading = false;
        this.empty = true;
      });
  },
  computed: {
    ...mapGetters("dataPolice", ["showData"])
  },
  methods: {
    ...mapActions(["deviceClass"]),
    ...mapActions("dataPolice", ["policeMessage"]),
    createDataGroup(alarmList) {
      let groups = [];
      let index = 0;
      let group = [];
      for (let i = 0; i < alarmList.length; ++i) {
        group.push(alarmList[i]);
        index++;
        if (index === 6 || i === alarmList.length - 1) {
          index = 0;
          groups.push(group);
          group = [];
        }
      }
      return groups;
    }
  }
}
</script>

<template>
  <div
    id="police-history"
    class="police-history">
    <!-- 加载样式 -->
    <Spin class="loading" v-if="loading">
      <div class="loading-container">
        <Icon class="demo-spin-icon-load" type="ios-loading" size=18></Icon>
        <div class="loading-text">加载中...</div>
      </div>
    </Spin>
    <!-- 报警信息数据 -->
    <div class="empty" v-else-if="empty">
      <img class="empty-icon" src="../../assets/security.png" />
      <div class="empty-text">暂无传感器报警，您的园区很安全</div>
    </div>
    <!-- 报警内容 -->
    <div class="content" v-else>
      <transition-group
        class="scroll-view"
        name="scroll-item"
        tag="ul">
        <li
          class="scroll-item"
          v-for="item in showData"
          :key="item.id"
          :class="item.show_id % 2 === 0 ? 'scroll-item-blue' : 'scroll-item-dark'">
          <div class="scroll-item-col scroll-item-width-col1">
            <div class="scroll-item-icon">{{ item.show_id }}</div>
          </div>
          <div class="scroll-item-col scroll-item-width-col4">
            {{ item.name }}
          </div>
          <div class="scroll-item-col scroll-item-width-col7">
            {{ item.str }}
          </div>
          <div class="scroll-item-col scroll-item-width-col7">
            {{ item.create_time }}
          </div>
        </li>
      </transition-group>
    </div>
  </div>
</template>

<style scoped>
.police-history {
  position: relative;
  width: 100%;
  height: 80%;
  padding-left: 1vw;
  padding-right: 1vw;
  padding-bottom: 1vw;
}

.content {
  position: relative;
  width: 100%;
  height: 100%;
}

.scroll-view {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}



.scroll-item {
  position: relative;
  width: 100%;
  height: 20%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  font-size: 1vw;
  overflow: hidden;
  transition-property: all;
  transition-duration: 1.2s;
  transition-timing-function: ease;
}

.scroll-item-leave {
  height: 20%;
}

.scroll-item-leave-to {
  height: 0;
}

.scroll-item-blue {
  background-color: rgb(0, 59, 81);
}

.scroll-item-dark {
  background-color: rgb(10, 39, 50);
}

.scroll-item-col {
  color: #ffffff;
  text-align: center;
  font-size: 0.7vw;
}

.scroll-item-icon {
  width: 1.5vw;
  height: 1.5vw;
  line-height: 1.5vw;
  text-align: center;
  font-size: 0.7vw;
  border-radius: 0.75vw;
  background-color: rgb(0, 186, 255);
  margin: 0 auto;
}

.scroll-item-width-col1 {
  width: 12%;
}

.scroll-item-width-col4 {
  width: 24%;
}

.scroll-item-width-col7 {
  width: 32%;
}

.loading {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-container {
  display: flex;
  align-items: center;
}

.loading-text {
  padding-left: 0.2vw;
  font-size: 0.6vw;
}

.empty {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-icon {
  width: 1vw;
  height: 1vw;
}

.empty-text {
  padding-left: 0.2vw;
  color: #808695;
  font-size: 0.6vw;
}
</style>
